//Retrive last background and apply to back-to-top
import './back-to-top.scss';

export class BackToTopDynamicBackground {

  constructor() {

    this.foundPageType = false;

    if (document.querySelector('.js-last-element-bg')) {
      const backToTopElement = document.getElementById('js-back-to-top');
      let nodeLastChild = document.querySelector('.js-last-element-bg');
      nodeLastChild = this.checkIfBiographiePage(nodeLastChild);
      if (!this.foundPageType) {
        nodeLastChild = nodeLastChild.lastElementChild;
        nodeLastChild = this.checkIfBookmarkPage(nodeLastChild);
        nodeLastChild = this.checkIfDetaillantPage(nodeLastChild);
        nodeLastChild = this.checkIfArticle(nodeLastChild);
        nodeLastChild = this.checkIfParagraphPage(nodeLastChild);
      }

      nodeLastChild.classList.forEach((singleClass) => {
        if (backToTopElement && singleClass.match(/^bg-/)) {
          backToTopElement.classList.add(singleClass);
        }
      })
    }
  }

  checkIfBiographiePage(nodeLastChild) {

    let isBiographie = nodeLastChild.classList.contains('biographie-full');
    if (isBiographie && !this.foundPageType) {
      this.foundPageType = true;
    }
    return nodeLastChild
  }

  checkIfBookmarkPage(nodeLastChild) {

    let isBookmark = nodeLastChild.querySelector('.bookmark-page');
    if (isBookmark && !this.foundPageType) {
      nodeLastChild = isBookmark.querySelector(':scope > div');
      this.foundPageType = true;
    }
    return nodeLastChild
  }


  checkIfArticle(nodeLastChild) {
    if (nodeLastChild.classList.contains('field--name-field-related-articles') || nodeLastChild.classList.contains('field--name-field-jumbotron-image-expert') && !this.foundPageType) {
      nodeLastChild = nodeLastChild.lastElementChild;
      this.foundPageType = true;
    }
    return nodeLastChild
  }

  checkIfDetaillantPage(nodeLastChild) {
    if (nodeLastChild.classList.contains('detaillant-contact') || nodeLastChild.querySelector('#block-trouverundetaillant') && !this.foundPageType) {
      if (nodeLastChild.querySelector('#block-trouverundetaillant')) {
        nodeLastChild = nodeLastChild.querySelector('#block-trouverundetaillant');
      } else {
        nodeLastChild = nodeLastChild.lastElementChild;
      }

      this.foundPageType = true;
    }
    return nodeLastChild
  }

  checkIfParagraphPage(nodeLastChild) {
    let field_items;
    if (nodeLastChild.classList.contains('field__items') || nodeLastChild.classList.contains('field__item') || nodeLastChild.classList.contains('field') && !this.foundPageType) {
      if (nodeLastChild.classList.contains('field__item')) {
        nodeLastChild = nodeLastChild.querySelector('.paragraph');
      } else {
        field_items = nodeLastChild.querySelectorAll(':scope > .field__item');
        let item = field_items[field_items.length - 1];
        nodeLastChild = item.lastElementChild;
        this.foundPageType = true;
      }
    }
    return nodeLastChild
  }
}

window.addEventListener('DOMContentLoaded', () => {
  new BackToTopDynamicBackground();
});
